<template>
    <v-dialog v-model="showDialog" scrollable persistent transition="dialog-bottom-transition">
        <v-card>
            <v-card-title class="pa-0">
                <v-toolbar card dark color="primary">
                    <v-btn icon dark @click="$emit('close')">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-toolbar-title>Scouting Sync Errors</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                    </v-toolbar-items>
                </v-toolbar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container fluid class="pa-3 ma-0" grid-list-lg>
                    <v-layout row wrap>
                        <v-flex v-for="(error, index) in syncErrors" :key="index" xs12>
                            <v-expansion-panel :key="index">
                                <v-expansion-panel-content>
                                    <template v-slot:header>
                                        <v-alert :value="true" type="error" class="mr-4">
                                            <span>{{ error.Message }}</span>
                                        </v-alert>
                                    </template>
                                    <v-container class="pa-2">
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <span class="font-weight-bold">Scouting</span>
                                            </v-flex>
                                            <v-flex xs12>
                                                <span>{{ error.Scouting }}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            showDialog: false
        }
    },
    props: [
        "syncErrors"
    ],
    components: {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
    mounted() {
        // doing this in mounted (rather than created) means the dialog animation is shown
        this.showDialog = true;
    }
}
</script>
